import React from 'react';
import FormInput from 'components/forms/bases/FormInput';

const FormLink = ({ value, onChange, style, disabled, props }) => (
  <FormInput
    label="Link to"
    placeholder="ex. promotion"
    onChange={onChange}
    value={value}
    style={style}
    disabled={disabled}
    {...props}
  />
);

FormLink.propTypes = {};
FormLink.defaultProps = {};

export default FormLink;



// WEBPACK FOOTER //
// ./src/components/forms/FormLink.js